import React, { createContext, useContext, useState } from "react";
import { AppState, AppContextType, DEFAULT_APP_STATE } from "./types";

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider: React.FC<any> = ({ children }) => {
  const [entry, setEntry] = useState(DEFAULT_APP_STATE.entry);
  const [latestEntries, setLatestEntries] = useState(
    DEFAULT_APP_STATE.latestEntries,
  );
  const [query, setQuery] = useState(DEFAULT_APP_STATE.query);
  const [workspaceNavigation, setWorkspaceNavigation] = useState(
    DEFAULT_APP_STATE.workspaceNavigation,
  );
  const [userProfile, setUserProfile] = useState(DEFAULT_APP_STATE.userProfile);
  const [userProfileNeedsReload, setUserProfileNeedsReload] = useState<boolean>(
    DEFAULT_APP_STATE.userProfileNeedsReload,
  );

  const state: AppState = {
    ...DEFAULT_APP_STATE,
    entry,
    latestEntries,
    query,
    workspaceNavigation,
    userProfile,
    userProfileNeedsReload,
  };

  const context: AppContextType = {
    state,
    setEntry,
    setLatestEntries,
    setQuery,
    setWorkspaceNavigation,
    setUserProfile,
    setUserProfileNeedsReload,
  };

  return <AppContext.Provider value={context}>{children}</AppContext.Provider>;
};

export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within AppProvider");
  }
  return context;
};
